import { graphql } from "gatsby";
import React from "react";
import { LayoutContainer } from "../containers/layout";
import PageHeadMeta from "../components/global/page-head-meta";
import { AgentPage } from "../components/agent-page";

// "CMS Default" workflow
export const DEFAULT_COPILOT = "copilot_cmb8a224l00070es6kd0vd27w";
export const DEFAULT_WORKFLOW = "wf_cmb89wwsm00010fs6o590orrq";

export const query = graphql`
  query AgentTemplateQuery($id: String!) {
    doc: sanityAgent(id: { eq: $id }) {
      ...Agent
    }
  }
`;

const AgentTemplate = ({ data }) => (
  <LayoutContainer doc={{ ...data.doc, backgroundColor: "lightGreen" }}>
    <PageHeadMeta title={data.doc.title} doc={data.doc} />
    {data.doc && (
      <AgentPage
        {...data.doc}
        copilotID={data.doc.copilot_id || DEFAULT_COPILOT}
        workflowID={data.doc.workflow_id || DEFAULT_WORKFLOW}
      />
    )}
  </LayoutContainer>
);

export default AgentTemplate;
